/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Footer_ContactInputs */

const en_fc_footer_contact = /** @type {(inputs: Fc_Footer_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact support`)
};

/**
* | output |
* | --- |
* | "Contact support" |
*
* @param {Fc_Footer_ContactInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_footer_contact = /** @type {((inputs?: Fc_Footer_ContactInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Footer_ContactInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_footer_contact(inputs)
});
export { fc_footer_contact as "fc.footer.contact" }